import { Currencies, CurrenciesCrypto, CurrenciesFiat, CryptoAddressProtocol } from '@sparling/financial-common'

const crmCurrencies = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const currency in Currencies) {
  crmCurrencies.push({
    value: currency,
    label: Currencies[currency as keyof typeof Currencies],
  })
}

export const CRM_CURRENCIES = crmCurrencies
export const CRM_CURRENCIES_CRYPTO = CurrenciesCrypto
export const CRM_CURRENCIES_FIAT = CurrenciesFiat

export const isCurrenciesCrypto = (currency: string): boolean => {
  return currency in CRM_CURRENCIES_CRYPTO
}

export const isCurrenciesFiat = (currency: string): boolean => {
  return currency in CRM_CURRENCIES_FIAT
}

export const currencyCryptoOrFiat = (currency: string | undefined): string => {
  if (!currency) return ''

  if (isCurrenciesCrypto(currency)) {
    return 'crypto'
  }
  if (isCurrenciesFiat(currency)) {
    return 'fiat'
  }
  // eslint-disable-next-line
  console.error('no such currency exists')
  return ''
}

const crypto = []
const fiat = []
const currencies = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in CurrenciesCrypto) {
  crypto.push({
    value: item,
    label: item,
  })
}

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in CurrenciesFiat) {
  fiat.push({
    value: item,
    label: item,
  })
}

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in Currencies) {
  currencies.push({
    value: item,
    label: item,
  })
}

export const CURRENCIES = currencies

export const CURRENCIES_CRYPTO = crypto

export const CURRENCIES_FIAT = fiat

export const ADDRESS_PROTOCOL = Object.values(CryptoAddressProtocol).map((value) => ({ value, label: value }))
